import { Routes } from '@angular/router';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { DeveloperPlatformComponent } from './developer-platform.component';

export const developerPlatformRoutes: Routes = [
  {
    path: 'developer-platform',
    component: DeveloperPlatformComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      enterpriseModules: ['API_PLATFORM'],
      enterpriseFeatureLabel: 'LogiLink Enterprise API',
      permission: app_permissions.developer_platform.view
    }
  }
];
